<div id="app-question-card" [dir]="dir">
    <div class="card pointer" (click)="onSelectQuestion()">
        <div>
            <div class="flex flex-align">
                <div class="aOrder {{question._id == selectedId ? 'selected': ''}}">{{question.displayOrder}}</div>
                <div class="icons-padding-inline {{question.status ? '' : 'not-complete'}}" [innerHTML]="hitIcons">
                </div>
            </div>
            <div class="content flex">
                <div class="grow ctitle">
                    <h4>{{question.name}}</h4>
                </div>
                <div class="cContainer">
                    <div class="question"></div>
                </div>
            </div>
            <br />
            <br />
        </div>
        <div class="footer">
            <div>
            </div>
            <app-assessment-status [status]="question.status"></app-assessment-status>
        </div>
    </div>
</div>